import { getEmbarcacaoComercial } from "./embarcacoes.gateway";
import { isEmbarcacaoComercialEmpty } from "./embarcacoes.types";
import type { EmbarcacaoComercial, EmbarcacaoComercialState } from "./embarcacoes.types";
import { useEmbarcacaoDetailSection } from "./use-embarcacao-detail-section";
import type { EmbarcacaoDetailSectionQuery } from "./use-embarcacao-detail-section";

export const COMERCIAL_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const COMERCIAL_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const COMERCIAL_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const COMERCIAL_ERROR_MESSAGE =
  "Não foi possível carregar as informações Comerciais da embarcação.";

/** Constante de módulo: a consulta não muda entre renderizações da seção. */
const COMERCIAL_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoComercial> = {
  load: getEmbarcacaoComercial,
  isEmpty: isEmbarcacaoComercialEmpty,
  messages: {
    sessionExpired: COMERCIAL_SESSION_EXPIRED_MESSAGE,
    forbidden: COMERCIAL_FORBIDDEN_MESSAGE,
    notFound: COMERCIAL_NOT_FOUND_MESSAGE,
    error: COMERCIAL_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoComercialResult extends EmbarcacaoComercialState {
  reload: () => void;
}

/**
 * Consulta a seção Comercial da embarcação pedida. Somente leitura: a seção
 * não oferece nenhum recurso de escrita (AC5).
 */
export function useEmbarcacaoComercial(id: string): UseEmbarcacaoComercialResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, COMERCIAL_QUERY);

  return { ...state, comercial: data };
}
